//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLE / MUI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  CardContent,
  Grid,
} from '@mui/material';

// === API ===
import { onFileRuleInfo , removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function FileInfo(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ info , setInfo ] = useState( { open: 0, closed: 0, total: 0 } );

  //#endregion

  //#region [STYLES]

  const _styles = {
    card: {
      height    : 'calc( 100% - 12px)',
      width     : 'calc( 100% )',
      display   : 'block',
      borderRadius : '10px',
      padding: 0,
      margins: 0,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    card_content_header: {
      height    : '50%',
      width     : 'calc( 100% )',
      display   : 'flex',
      borderRadius : '10px 10px 0 0',
      textAlign : 'center',
      justifyContent : 'center',
      padding: 0,
      margin: 0,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    card_content: {
      height    : '50%',
      width     : 'calc( 100% )',
      display   : 'flex',
      textAlign : 'center',
      justifyContent : 'center',
      padding: 0,
      margin: 0,
      marginTop: '0.5rem',
    },
    item: {
      margin: 'auto',
      fontWeight: 'bold',
    },
    item_open: {
      margin: 'auto',
      fontWeight: 'bold',
      color: theme.palette.error.main,
    },
    item_closed: {
      margin: 'auto',
      fontWeight: 'bold',
      color: theme.palette.success.main,
    },
    table_container: {
      height    : 'calc( 100% - 1rem)',
      width     : '100%',
      maxWidth  : '100%',
      overflowY : 'hidden',
    },
    task_queue_text: {
      margin: '1rem',
    },
    table_header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    text_error: {
      color: theme.palette.error.main,
    }
  };

  //#endregion

  //#region [EFFECT]

  //-----------------------------------------------------------------
  useEffect( () => {
    //-----------------------------------------------------------------
    
    //-----------------------------------------------------------------
    function handleFileRuleInfo(data) {
      //-----------------------------------------------------------------
      setInfo( data );
    }

    onFileRuleInfo( handleFileRuleInfo );

    return () => {
      removeListener( 'FILE-RULE-INFO', handleFileRuleInfo );
    }
  }, [] );

  //#endregion

  //#region [DISPLAY]

  const display_number = (value) => isNaN(value) ? '-' : value;

  //-----------------------------------------------------------------
  function dislpay() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.card}>
        <CardContent key={1} sx={_styles.card_content_header}>
          <Grid container>
            <Grid item xs={2} key={0} sx={_styles.item}>{ ' '      }</Grid>
            <Grid item xs={2} key={1} sx={_styles.item}>{ 'Open'   }</Grid>
            <Grid item xs={2} key={2} sx={_styles.item}>{ 'Total'  }</Grid>
            <Grid item xs={2} key={3} sx={_styles.item}>{ 'Closed' }</Grid>
            <Grid item xs={2} key={4} sx={_styles.item}>{ ' '      }</Grid>
          </Grid>
        </CardContent>
        <CardContent key={2} sx={_styles.card_content}>
          <Grid container>
            <Grid item xs={2} key={0} sx={_styles.item        }>{ ''                            }</Grid>
            <Grid item xs={2} key={1} sx={_styles.item_open   }>{ display_number( info.open   ) }</Grid>
            <Grid item xs={2} key={2} sx={_styles.item        }>{ display_number( info.total  ) }</Grid>
            <Grid item xs={2} key={3} sx={_styles.item_closed }>{ display_number( info.closed ) }</Grid>
            <Grid item xs={2} key={4} sx={_styles.item        }>{ ''                            }</Grid>
          </Grid>
        </CardContent>
      </Box>
    );
  }

  //#endregion

  return dislpay();
}